module.exports = __webpack_public_path__ + "static/img/200067.df377955.png";